<div class="overlay" style="text-align: center" *ngIf="loader">
  <div class="loading-container">
    <div class="loading-circle"></div>
    <img
      src="../../../assets/images/bmc_icon.png"
      alt="Your Image"
      class="centered-image"
    />
  </div>
</div>
